<template>
  <div>
    <page-header v-if="courseTitle" :title="courseTitle" />
    <p style="margin-top: 10px">
      {{ chapterInfo.title }}
    </p>
    <el-row :gutter="20" type="flex">
      <el-col :span="16">
        <div ref="chapterRef" style="margin-bottom: 1em" class="top">
          <div v-if="chapterInfo && chapterInfo.type == 4" class="live-wrap">
            <div style="padding: 20px">
              <p v-if="chapterInfo.extra_content.recorded_url" class="chapter-info">
                录播地址：<a :href="chapterInfo.extra_content.recorded_url" target="_blank" rel="noopener noreferrer">{{ chapterInfo.extra_content.recorded_url }}</a>
              </p>
            </div>
          </div>
          <div v-if="chapterInfo && chapterInfo.type == 2" class="live-wrap">
            <div style="padding: 20px">
              <template v-if="chapterInfo.extra_content">
                <p class="chapter-info" v-html="chapterInfo?.extra_content?.remark"></p>
                <p v-if="chapterInfo.extra_content.TencentUrl" class="chapter-info">
                  会议链接：<a :href="chapterInfo.extra_content.TencentUrl" target="_blank" rel="noopener noreferrer">{{ chapterInfo.extra_content.TencentUrl }}</a>
                </p>
                <p v-if="chapterInfo.extra_content.TencentCode" class="chapter-info">会议号：{{ chapterInfo.extra_content.TencentCode }}</p>
                <p v-if="chapterInfo.extra_content.back_url" class="chapter-info">
                  回放地址：<a :href="chapterInfo.extra_content.back_url" target="_blank" rel="noopener noreferrer">{{ chapterInfo.extra_content.back_url }}</a>
                </p>
              </template>
              <div v-else style="color: #999; padding: 3em; text-align: center">暂无直播信息，敬请期待</div>
            </div>
          </div>
          <div v-if="chapterInfo && chapterInfo.type == 1" :style="{ 'min-height': `${height}px` }" class="video-wrap">
            <!-- {{ isInit }}，{{ chapterInfo.extra_content.video_id }} -->
            <div v-show="chapterInfo.extra_content && chapterInfo.extra_content.video_id" id="videoContainer" :style="{ height: `${height}px` }"></div>
            <div v-if="!chapterInfo.extra_content || !chapterInfo.extra_content.video_id" style="color: #999">该章节暂无视频</div>
          </div>
        </div>

        <div v-if="chapterInfo && chapterInfo.intro" style="padding: 20px; background-color: #fff; margin-bottom: 20px">
          <h4>介绍</h4>
          <p class="chapter-info" v-html="chapterInfo.intro"></p>
        </div>
        <div v-if="chapterInfo && chapterInfo.file && chapterInfo.file?.length > 0" style="padding: 20px; background-color: #fff">
          <h4>课件</h4>
          <p v-for="item in chapterInfo.file" :key="item.id">
            <a :href="item.url" target="_blank">{{ item.name }}</a>
          </p>
        </div>
      </el-col>
      <el-col :span="8"><div>
        <div v-if="chapterList && chapterList.length" class="Chapter-list">
          <div v-for="item in chapterList" :key="item.id">
            <h4>{{ item.title }}</h4>
            <ul>
              <li v-for="el in item.children" :key="el.id" :class="{ active: el.id === chapterInfo.id }" @click="selectChapter(el)">
                <span>【{{ el.type == 4 ? '录播' : el.typeText || '--' }}】</span>
                <div>{{ el.title }}</div>
                <!-- 已学习 -->
                <span v-if="el.type === 1 && el.extra_content && el.extra_content.duration" class="time" :class="{ done: el.attendance }">
                  {{ el.attendance ? el.attendance : formatTime(el.extra_content.duration) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      </el-col>
    </el-row>

    <el-empty v-if="chapterList && !chapterList.length" description="当前课程暂无课程安排"></el-empty>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import API from '@/api'
import Router from '@/router'
import PageHeader from '@/components/PageHeader'

const chapterList = ref(null)
const ctId = Router.currentRoute.query.ctId
const courseTitle = Router.currentRoute.query.courseTitle
const chapterRef = ref(null)
const chapterInfo = ref({})
const getCourseDetail = () => {
  API.getCourseDetail(ctId).then(res => {
    if (+res.code === 200) {
      chapterList.value = res.data.list
      const chapterId = Router.currentRoute.query.lastChapterId

      res.data.list?.find(el => {
        el.children?.find(item => {
          if (item.id === +chapterId) {
            chapterInfo.value = item
          }
        })
      })

      if (chapterId) {
        selectChapter(chapterInfo.value)
      } else {
        if (chapterList.value.length > 0) {
          selectChapter(chapterList.value[0].children[0])
        }
      }
    }
  })
}
const defaultOptions = {
  categoryid: '415B24EE59182978',
  userid: '5AF1789CBE09E77C',
  maxChunkSize: 4 * 1024 * 1024,
  playerid: '4A58FDBD7ECFBE98'
}
const isInit = ref(false)
const initPlayer = el => {
  setTimeout(() => {
    document.getElementById('videoContainer').innerHTML = ''
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = `https://p.bokecc.com/player?vid=${el.extra_content.video_id}&siteid=${defaultOptions.userid}&autoStart=true&width=${width.value}&height=${height.value}&playerid=${defaultOptions.playerid}&playertype=2`

    document.getElementById('videoContainer').appendChild(s)
  })
}

const selectChapter = el => {
  if (chapterInfo.value.type === 1) {
    playerpauseHandle()
  }
  chapterInfo.value = el
  isInit.value = false
  if (+el.type === 1 && el.extra_content) {
    if (el.extra_content.video_id) {
      isInit.value = true
      initPlayer(el)
    }
  }
}
const width = ref(null)
const height = ref(null)
const resizeChange = () => {
  width.value = chapterRef.value?.offsetWidth
  height.value = width.value / 1.78
}

const videoPositionStart = ref(0)
const videoPositionEnd = ref(0)
const study_time = ref(0)
const timer = ref(null)

const player_start = () => {
  console.log('cc视频 播放开始')
  const oVideo = document.getElementsByTagName('video')[0]
  videoPositionStart.value = oVideo?.currentTime
  study_time.value = 0
  clearInterval(timer.value)
  timer.value = setInterval(() => {
    study_time.value++
  }, 1000)
}

const player_pause = () => {
  console.log('cc视频 播放暂停')
  playerpauseHandle()
}

const player_end = () => {
  console.log('cc视频 播放结束')
  playerpauseHandle()

  const currentChapterIndex = chapterList.value.findIndex(item => item.children?.some(child => child.id === chapterInfo.value.id))
  const currentChapter = chapterList.value[currentChapterIndex]
  const currentChildIndex = currentChapter.children.findIndex(child => child.id === chapterInfo.value.id)
  currentChapter.children[currentChildIndex].type = 1

  if (currentChapter.children[currentChildIndex].attendance !== '已学习') {
    API.getJieStudyState(chapterInfo.value.id).then(res => {
      if (+res.code === 200) {
        currentChapter.children[currentChildIndex].attendance = res.data.list.text
      }
    })
  }

  if (currentChildIndex < currentChapter?.children?.length - 1) {
    selectChapter(currentChapter.children[currentChildIndex + 1])
  } else if (currentChapterIndex < chapterList.value.length - 1) {
    const nextChapter = chapterList.value[currentChapterIndex + 1]
    if (nextChapter?.children.length > 0) {
      selectChapter(nextChapter.children[0])
    }
  }
}

const playerpauseHandle = () => {
  console.log(new Date())
  const oVideo = document.getElementsByTagName('video')[0]
  videoPositionEnd.value = oVideo?.currentTime
  clearInterval(timer.value)
  updateVideoRecord()
}

const updateVideoRecord = () => {
  if (study_time.value > 0) {
    const params = {
      ct_id: ctId,
      course_table_chapter_id: chapterInfo.value.id,
      duration_stime: Math.floor(videoPositionStart.value),
      duration_etime: Math.floor(videoPositionEnd.value),
      study_time: study_time.value
    }
    API.updateStudyLog({ CourseTableStudyLog: params }).then(res => {
      if (res && +res.code === 200) {
        console.log('更新成功')
      }
    })
  }
}

const onResize = () => {
  resizeChange()
}

// 导航守卫，在离开当前路由时记录观看时长
const removeBeforeRouteLeave = Router.beforeEach((to, from, next) => {
  if (chapterInfo.value.type === 1) {
    playerpauseHandle()
  }
  next()
})

onMounted(() => {
  getCourseDetail()
  resizeChange()
  window.addEventListener('resize', onResize)
  window.on_CCH5player_play = () => {
    player_start()
  }
  window.on_CCH5player_pause = () => {
    player_pause()
  }
  window.on_CCH5player_ended = () => {
    player_end()
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
  clearInterval(timer.value)
  removeBeforeRouteLeave() // 移除导航守卫
})

const formatTime = time => {
  const h = Math.floor(time / 3600)
  const m = Math.floor((time % 3600) / 60)
  const s = Math.floor(time % 60)

  if (h > 0) {
    return `${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`
  } else {
    return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`
  }
}
</script>

<style lang="scss">
.CCH5playerContainer,
.CCH5playerContainer > div {
  width: 100% !important;
  height: 100% !important;
}
#videoContainer {
  background: #000;
  width: 100%;
}
.live-wrap {
  background: #fff;
}

.video-wrap {
  display: flex;
  background: #fff;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.chapter-info {
  white-space: break-spaces;
  line-height: 1.75;
}
.Chapter-list {
  background: #fff;
  padding: 16px;
  color: #18191c;
  border-radius: 5px;
  h3 {
    font-weight: normal;
    font-size: 1.25em;
  }
  h4 {
    margin: 0.5em 0;
    font-size: 16px;
  }

  ul {
    padding-left: 1em;
    line-height: 1.5;
    list-style: none;
    padding: 0;

    li {
      margin: 8px 0;
      color: #555;
      cursor: pointer;
      width: 100%;
      display: flex;
      align-items: center;
      &.active,
      &:hover {
        color: var(--theme-color);
      }
      div {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      span {
        flex-shrink: 0;
      }
      .time {
        margin-left: auto;
        padding-left: 1em;
        flex-shrink: 0;
        &.done {
          color: #67c23a;
        }
      }
    }
  }
}
</style>
